
import { useDesignerStore } from "../store";

export default function SizePanel() {

  const width = useDesignerStore((state) => state.selectedWidth);
  const height = useDesignerStore((state) => state.selectedHeight);

  return (
    <div className="rounded-xl bg-slate-800 border border-slate-700 p-4 text-white">

      <h3 className="text-lg font-bold mb-4">
        📏 Print Size
      </h3>

      <div className="space-y-3">

        <div className="flex justify-between">
          <span className="text-slate-300">
            Width
          </span>

          <span className="font-semibold text-cyan-400">
            {width.toFixed(1)} cm
          </span>
        </div>

        <div className="flex justify-between">
          <span className="text-slate-300">
            Height
          </span>

          <span className="font-semibold text-cyan-400">
            {height.toFixed(1)} cm
          </span>
        </div>

      </div>

    </div>
  );
}